import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <a
        data-aos="fade-right"
        target="_blank"
        href="https://cli.ranjansharma.info.np/"
        className="btn"
        rel="noreferrer"
      >
        Resume
      </a>
      <a data-aos="fade-left" href="#contact" className="btn btn-primary" aria-label="Contact Ranjan Sharma">
        Let's Connect
      </a>
    </div>
  );
};

export default CTA;
